module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Rupperswil-dbc37ec7a7e4eddc6f07c9dc9da01055.svg";